import * as styled from "./StudentsByDate.styled";
import { useEffect, useState } from "react";
import axios from "../../axios.js";
import { useNavigate } from "react-router-dom";
import { ageGroups } from "../../helpers/ageGroups.js";
import Papa from "papaparse";

function StudentsByDate({ route, isTrial, statusOptions }) {
  const navigate = useNavigate();
  const [students, setStudents] = useState([]);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [ageGroup, setAgeGroup] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const fetchStudentsByDate = async () => {
    try {
      setLoading(true);
      const res = await axios.get(route, {
        params: {
          from,
          to,
          ageGroup,
          ...(isTrial && status ? { status } : {}),
        },
      });
      setStudents(res.data.students);
    } catch (err) {
      console.error("Error fetching students by date", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1)
      .toISOString()
      .split("T")[0];
    const end = new Date().toISOString().split("T")[0];

    setFrom(start);
    setTo(end);
  }, []);

  const handleExportCSV = () => {
    if (students.length === 0) {
      alert("Немає даних для експорту.");
      return;
    }

    const csvData = students.map((s) => ({
      Імʼя: s.name,
      ID: s.studentId,
      "Дата додавання": new Date(s.createdAt).toLocaleDateString(),
      "Вікова група": s.ageGroup,
      ...(isTrial
        ? {
            Статус:
              statusOptions.find((res) => res.value === s.lessonStatus)
                ?.label || "Невідомо",
          }
        : {}),
    }));

    const csv = Papa.unparse(csvData, {
      quotes: false,
      delimiter: ",",
      skipEmptyLines: true,
    });

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    const date = new Date().toISOString().split("T")[0];
    link.download = `students-${date}.csv`;
    link.click();
  };

  return (
    <>
      <styled.FiltersWrapper>
        <styled.LabelsWrapper>
          <label>
            Від:
            <input
              type="date"
              value={from}
              onChange={(e) => setFrom(e.target.value)}
            />
          </label>
          <label>
            До:
            <input
              type="date"
              value={to}
              onChange={(e) => setTo(e.target.value)}
            />
          </label>
          <label>
            Вікова група:
            <select
              value={ageGroup}
              onChange={(e) => setAgeGroup(e.target.value)}
            >
              <option value="">Всі</option>
              {ageGroups.map(({ name, value }) => (
                <option key={value} value={value}>
                  {name}
                </option>
              ))}
            </select>
          </label>
          {isTrial && (
            <label>
              Статус:
              <select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="">Всі</option>
                {statusOptions.map(({ label, value }) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </select>
            </label>
          )}
        </styled.LabelsWrapper>

        <styled.ButtonsWrapper>
          <button onClick={fetchStudentsByDate}>Пошук</button>
          {students.length > 0 && (
            <button onClick={handleExportCSV}>Вигрузити в CSV</button>
          )}
        </styled.ButtonsWrapper>
      </styled.FiltersWrapper>

      {loading && <p>Завантаження...</p>}

      {!loading && (
        <>
          <p>Знайдено учнів: {students.length}</p>

          <styled.StudentsList>
            {students.map((student) => (
              <styled.StudentCard
                key={student._id}
                onClick={() => navigate(`${student.ageGroup}/${student._id}`)}
              >
                <p>
                  {student.name} ({student.studentId})
                </p>
                <p>
                  {isTrial ? "Додали пробний" : "Почав навчання:"}{" "}
                  {new Date(student.createdAt).toLocaleDateString()}
                </p>
                <p>Група: {student.ageGroup}</p>
                {isTrial && (
                  <p>
                    Статус:{" "}
                    {statusOptions.find(
                      (res) => res.value === student.lessonStatus
                    )?.label || "Неизвестно"}
                  </p>
                )}
                {isTrial && (
                  <p>
                    Note: {student.notes}
                  </p>
                )}
              </styled.StudentCard>
            ))}
          </styled.StudentsList>
        </>
      )}
    </>
  );
}

export default StudentsByDate;
